<template>
<div>
  <div class="container">
      <h2 class="mt-5">Our latest litter</h2>
      <hr class="line text-left" style="margin-bottom:20px; margin-top:-5px" />
      <!-- <div class="row">
        <div class="col mx-auto">
          <img src="https://firebasestorage.googleapis.com/v0/b/dogodicattaro-ccec6.appspot.com/o/all%2Fdogo.jpg?alt=media&token=965c25a9-d052-43ae-afab-673aba1c4b1f"  class="d-block w-100"
            width="100%"
            height="100%" alt="">
  </div></div> -->
   <v-carousel>
    <v-carousel-item
      v-for="(item,i) in myPuppies"
      :key="i"
      reverse-transition="fade-transition"
      transition="fade-transition"
    >
    <!-- {{item.src}} -->
        <v-img v-if="item" :src="item.src" contain max-height="100%" @error="onerror(i)"/>
        <v-btn v-if="user1" @click="removeImage(item, i)" color="primary" style="position: absolute;top:1px;">Obrisi</v-btn>
    </v-carousel-item>
  </v-carousel>
  </div>
    <Footer />
  </div>
</template>


<script>
import Footer from "@/components/Footer.vue";
import * as firebase from "firebase";
export default {
  components: {
    Footer
  },
  data(){
    return {
      showImage: true,
      myPuppies: []
    }
  },
  async created() {
    const data = await this.$store.dispatch("getPuppies");
    if(data) {
      const test = await data.map(async(item)=> {
        const imageExists = await this.doesImageExist(item.src);
        return imageExists ? item : null;
      });
      if(test) {
        const t1 = await Promise.all(test);
        this.myPuppies = t1.filter((item)=> item != null);
      }
    }
  },
  computed: {
    puppies() {
      return this.$store.getters.getAllPuppies;
    },
      user1() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
  },

  methods: {
    onerror(item) {
      console.log(item);
      // item.showImage = false;
      // this.myPuppies.
      this.myPuppies.splice(item, 1);
    },
    doesImageExist(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
        // console.log(img.onerror);
      });
  },
  removeImage(item, index) {
    // console.log('Remvoe', item);
    const puppyRef = firebase.firestore().collection('puppies').where('src', '==', item.src);
    puppyRef.get().then((query)=> {
      query.forEach((doc)=> {
        doc.ref.delete();
      })
    }).finally(()=> {
      this.myPuppies.splice(index, 1);
    })
  }
  }
}
</script>


<style scoped>
hr.line {
  border: 1px solid #ffd700;
  width: 100px;
  margin: 0px auto;
}

</style>